import React, { Fragment } from 'react';

import Link from '@atlaskit/link/link';
import { token } from '@atlaskit/tokens';

import AccentIcon from './components/accent-icon';
import type { ColorTable } from './types';

export const COLOR_ROLES: ColorTable[] = [
	{
		name: 'neutral',
		description: (
			<Fragment>
				Use for default text and secondary UI elements, such as secondary buttons or navigation
				elements.
			</Fragment>
		),
		token: token('color.icon'),
	},
	{
		name: 'brand',
		description: (
			<Fragment>Use for primary actions or elements that communicate the Atlassian brand.</Fragment>
		),
		token: token('color.background.brand.bold'),
	},
	{
		name: 'information',
		description: (
			<Fragment>
				Use for informative UI, such as an information icon, or UI that communicates something is in
				progress.
			</Fragment>
		),
		token: token('color.background.information.bold'),
	},
	{
		name: 'success',
		description: (
			<Fragment>Use to communicate a favorable outcome, such as a success message.</Fragment>
		),
		token: token('color.background.success.bold'),
	},
	{
		name: 'warning',
		description: (
			<Fragment>
				Use for UI that communicates caution to prevent a mistake or error from occurring.
			</Fragment>
		),
		token: token('color.background.warning.bold'),
	},
	{
		name: 'danger',
		description: <Fragment>Use for UI that communicates danger or serious error states.</Fragment>,
		token: token('color.background.danger.bold'),
	},
	{
		name: 'discovery',
		description: (
			<Fragment>
				Use for UI that communicates something new, such as onboarding or new feature information.
			</Fragment>
		),
		token: token('color.background.discovery.bold'),
	},
	{
		name: 'accent',
		description: (
			<Fragment>
				Use for colors that don't have any specific meaning tied to them. You should be able to
				exchange one accent color for another, and the experience would remain unchanged. <br />
				<br />
				Accent colors: gray, red, green, blue, yellow, orange, teal, purple, magenta, and lime.
			</Fragment>
		),
		icon: <AccentIcon />,
	},
	{
		name: 'inverse',
		description: (
			<Fragment>
				Use for UI elements that sit on bold{' '}
				<Link href="#use-inverse-tokens-on-bold-backgrounds">emphasis</Link> backgrounds.
			</Fragment>
		),
		token: token('color.icon.inverse'),
		background: token('color.background.neutral.bold'),
		inverse: true,
	},
	{
		name: 'input',
		description: (
			<Fragment>
				Use for form fields. (Note that design system form fields will already have tokens applied.)
			</Fragment>
		),
		token: token('color.border.input'),

		input: true,
	},
];
